<template>
  <div class="headerTop flex_between">
    <div class="leftHead flex_end"><img
      class="logo"
      src="../../assets/login_logo.svg">
    <p>{{$t('global.parentTitle')}}</p>
    </div>
    <el-dropdown @command="handleCommand">
      <el-button class="rightHead">
        <img src="../../assets/settings.svg">
        <p>{{$t('header.setting')}}</p>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="Reset">{{$t('header.resetPassword')}}</el-dropdown-item>
        <el-dropdown-item command="Logout">{{$t('header.logout')}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { clearStore } from '@/store';
export default {
  methods: {
    handleCommand (command) {
      if (command == 'Reset') {
        this.$http.post('/api/judePasswordIshad').then((res) => {
          if (res.data.code == 200) { // 设置过密码
            this.$message({
              message: res.data.data,
              type: 'success'
            })  
            this.$router.push({ path: '/resetPassword?type=1' })
          } else if (res.data.code == 400) { // 未设置过密码
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.$router.push({ path: '/resetPassword?type=0' })
          }
        })
        // this.$router.push({ path: '/resetPassword' })
      } else {
        this.$http.post('/api/user/logout').then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.data,
              type: 'success'
            })
            clearStore();
            this.$intercom.shutdown()
            this.$intercom.hide()
            this.$router.push({ path: '/' })
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .headerTop{
    width:1200px;
    height: 88px;
    margin:0 auto;
    font-family: Sofia Pro-Regular;
    font-size: 20px;
    color: #fff;
    .leftHead{
      .logo {
        width: 227px;
        height: 50px;
        img{
          width:100%;
          height:100%;
        }
      }
      p {
        margin-left:20px;
      }
    }
    /deep/ .el-dropdown{
      .rightHead{
        background: none;
        border:none;
        color:#fff;
        font-size: 16px;
        span{
          display: flex;
          align-items: center;
          font-size: 16px;
          font-family: Sofia Pro-Regular;
          img{
            width:20px;
            height:20px;
            margin-right:6px;
          }
          p{
            font-size: 16px;
          }
        }

      }
    }
  }
  // 设置下拉框
  /deep/ .el-dropdown-menu{
    width:180px;
    padding:6px 0;
    margin:0;
    font-family: Sofia Pro-Regular;
  }
  /deep/ .el-dropdown-menu__item{
    width:140px;
    background: #fff;
    color:#353643;
    font-size:16px;
    line-height: 40px;
    padding:0 20px;
  }
  /deep/ .popper__arrow{
    display: none;
  }
  /deep/ .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    background: rgba(255,100,64,0.30);
    font-size: 16px;
    font-family: Sofia Pro-Bold;
    font-weight: 700;
    color: #ff6440;
    letter-spacing: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/header.vue